import React from 'react';
import { motion, useAnimation} from "framer-motion"

const ExtraSection2 = () => {
  


  return (
        <section className=' py-[70px] md:py-[100px] bg-gradient-to-r from-secondary to-primary  '>
        <div  className="mx-auto max-w-[1170px] hero   ">
  <div 
        initial="hidden"
       className="hero-content flex-col items-start lg:flex-row-reverse justify-between gap-x-10">
    <div  data-aos="fade-down"
         data-aos-offset="300"
         data-aos-easing="ease-in-sine"   
       className="text-center lg:text-left">
      <h1  className="text-[30px] leading-[40px]  md:text-[48px] md:leading-[58px] font-bold">Car Selif Start Motor </h1>
      <p  className="py-6 text-[18px] leading-[30px] text-normal max-w-[700px]">When it comes to the efficiency and reliability of your vehicle, the car self start motor plays a pivotal role. This essential component, often taken for granted, is the heart of your vehicle's starting system. Without it, your car wouldn’t be able to power up and get you on the road. At our store, we provide the best car parts, including top-quality self start motors that guarantee a smooth start every time you turn the key.
      </p>
    </div>
    <div data-aos="fade-down-right"
         data-aos-offset="300"
   
         data-aos-easing="ease-in-sine"       className="card flex-shrink-0 w-full  max-w-sm shadow-2xl bg-base-100">
      <div  className="card-body">
        <img src="https://i.ibb.co/CVjdTMr/images-3.png" alt="" />
      </div>
    </div>
  </div>
</div>    



        </section>
    );
};

export default ExtraSection2;